import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-package-thankyou', 
  standalone: true,
  imports: [CommonModule],
  templateUrl: './package-thankyou.html',
  styleUrl: './package-thankyou.css',
})
export class PackageThankyou {

}
